import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { VesselVisitDocumentStatusCodes } from '@common/classes/vessel-visit-document-status-codes';
import { VesselVisitDocumentTypeCodes } from '@common/classes/vessel-visit-document-types';
import { CommonService } from '@common/services/common.service';

@Component({
    selector: 'app-general-data-segment',
    templateUrl: './general-data-segment.component.html',
    styleUrls: ['./general-data-segment.component.scss'],
    providers: [CommonService]
})
export class GeneralDataSegment implements OnInit {
    @Input() model: any;
    @Input() editMode: boolean;

    ngOnInit(): void {
        
    }    

    get createdByFullName(): string {
        return this.model?.createdBy?.fullName ?? '';
    }

    get lastModifiedByFullName(): string {
        return this.model?.lastModifiedBy?.fullName ?? '';
    }

    isDisabled(field: string): boolean {
        if (!this.editMode) {
            return true;
        }

        switch(field){
            case 'note':
                if(this.model.statusId !== VesselVisitDocumentStatusCodes.InProgress)
                    return true;
                break;            
        }

        return false;        
    }
}
